import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import React, { useState } from 'react';

const Markdown = ({ content, showFootnotes = true }: { content: string; showFootnotes?: boolean; }) => {
    const [footnote, setFootnote] = useState(null);

    const parseFootnotesOld = (text) => {

        if (typeof text !== 'string') return text;
        //const regex = /\[\^(\d+):\s(.*?)\]/g;
        //const regex = /\[\^(\d+):\s((?:\[[^\]]*\]|[^\]])*)\]/g;

        //const regex = /\[\^(\d+):\s((?:\[[^\]]*\]|[^\]])+)\]/g;
        const regex = /\[\^(\d+):\s(.*?)\]/g;
        const parts = [];
        let lastIndex = 0;
        let match;

        while ((match = regex.exec(text)) !== null) {
            parts.push(text.slice(lastIndex, match.index));
            const id = match[1];
            const note = match[2];
            if (showFootnotes) {
                parts.push(
                    <sup
                        key={match.index}
                        className="cursor-pointer text-blue-600 font-bold -ml-0.5 hover:text-blue-800"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setFootnote({ id, note });
                        }}
                    >
                        {id}
                    </sup>
                );
            }
            lastIndex = regex.lastIndex;
        }
        parts.push(text.slice(lastIndex));
        return parts;
    };

    const parseFootnotes = (text) => {
        if (typeof text !== 'string') return text;
        const regex = /\[\^(\d+):\s*([^\]]+)\]/g;
        const parts = [];
        let lastIndex = 0;
        let match;

        while ((match = regex.exec(text)) !== null) {
            parts.push(text.slice(lastIndex, match.index));
            const id = match[1];
            const note = match[2];
            if (showFootnotes) {
                parts.push(
                    <sup
                        key={match.index}
                        className="cursor-pointer text-amber-600 font-bold -ml-0.5 hover:text-amber-800"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setFootnote({ id, note });
                        }}
                    >
                        {id}
                    </sup>
                );
            }
            lastIndex = regex.lastIndex;
        }
        parts.push(text.slice(lastIndex));
        return parts;
    };

    const parseFootnotesa = (text) => {
        if (typeof text !== 'string') return text;
        const parts = [];
        let i = 0;

        while (i < text.length) {
            if (text.startsWith('[^', i)) {
                let depth = 1;
                let j = i + 1;
                // Scan for the balancing closing bracket
                while (j < text.length && depth > 0) {
                    j++;
                    if (text[j] === '[') depth++;
                    if (text[j] === ']') depth--;
                }

                if (depth === 0) {
                    const raw = text.slice(i + 2, j);
                    const colonIndex = raw.indexOf(':');
                    const id = raw.slice(0, colonIndex).trim();
                    const note = raw.slice(colonIndex + 1).trim();

                    if (showFootnotes) {
                        parts.push(
                            <sup
                                key={i}
                                className="cursor-pointer text-amber-600 font-bold -ml-0.5 hover:text-amber-800"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setFootnote({ id, note });
                                }}
                            >
                                {id}
                            </sup>
                        );
                    }
                    i = j + 1;
                    continue;
                }
            }
            parts.push(text[i]);
            i++;
        }
        return parts;
    };




    const inject = (children) => {

        return React.Children.map(children, (child) => {
            if (typeof child === 'string') return parseFootnotes(child);
            if (React.isValidElement(child) && child.props.children) {
                return React.cloneElement(child, {
                    children: inject(child.props.children),
                });
            }
            return child;
        });
    };

    return (
        <div className="relative">
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    h1: ({ children, ...props }) => <h1 className="text-3xl font-bold mt-0 mb-6 border-b pb-2" {...props}>{inject(children)}</h1>,
                    h2: ({ children, ...props }) => <h2 className="text-2xl font-bold mt-10 mb-4" {...props}>{inject(children)}</h2>,
                    h3: ({ children, ...props }) => <h3 className="text-xl font-bold mt-8 mb-4" {...props}>{inject(children)}</h3>,
                    h4: ({ children, ...props }) => <h4 className="text-lg font-bold mt-6 mb-2" {...props}>{inject(children)}</h4>,
                    p: ({ children, ...props }) => <p className="mb-6 leading-relaxed bloack" {...props}>{inject(children)}</p>,
                    ul: ({ children, ...props }) => <ul className="list-disc ml-6 mb-6 space-y-2" {...props}>{inject(children)}</ul>,
                    ol: ({ children, ...props }) => <ol className="list-decimal ml-6 mb-6 space-y-2" {...props}>{inject(children)}</ol>,
                    hr: ({ ...props }) => <hr className="mb-6" {...props} />,
                    li: ({ children, ...props }) => <li className="mb-1" {...props}>{inject(children)}</li>,
                    table: ({ ...props }) => (
                        <div className="overflow-x-auto my-8">
                            <table className="min-w-full border-collapse border border-gray-300 text-sm" {...props} />
                        </div>
                    ),
                    thead: ({ ...props }) => <thead className="bg-gray-100" {...props} />,
                    th: ({ children, ...props }) => <th className="border border-gray-300 p-3 text-left font-bold" {...props}>{inject(children)}</th>,
                    td: ({ children, ...props }) => <td className="border border-gray-300 p-3" {...props}>{inject(children)}</td>,
                    tr: ({ ...props }) => <tr className="even:bg-gray-50" {...props} />,
                    strong: ({ children, ...props }) => <strong className="font-bold text-black" {...props}>{inject(children)}</strong>,
                    em: ({ children, ...props }) => <em className="italic" {...props}>{inject(children)}</em>,
                    a: ({ href, children, ...props }) => {
                        const isVideo = href?.includes("rumble.com/embed") || href?.includes("youtube.com/embed");
                        if (!showFootnotes) return <>{children}</>;
                        const textContent = React.Children.toArray(children).join("");
                        if (textContent.includes("^")) return;// <>{inject(children)}</>;
                        const regex = /\[\^(\d+):\s*([^\]]+)\]/g;
                        let match = regex.exec(textContent);
                        if(match) return;

                        if (isVideo) {
                            return (
                                <div className="relative w-full aspect-video my-8 rounded-lg overflow-hidden shadow-lg">
                                    <iframe
                                        src={href}
                                        title="Video player"
                                        className="absolute top-0 left-0 w-full h-full border-0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    />
                                </div>
                            );
                        }
                        return (
                            <a
                                href={href}
                                className="text-amber-600 hover:underline cursor-pointer"
                                target="_blank"
                                rel="noopener noreferrer"
                                {...props}
                            >
                                {inject(children)}
                            </a>
                        );
                    }
                }}
            >
                {content}
            </ReactMarkdown>

            {footnote && (
                <div
                    className="fixed overflow-hidden overscroll-contain inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4"
                    onClick={() => setFootnote(null)}
                >
                    <div
                        className="bg-white rounded-lg p-6 max-w-md w-full shadow-2xl relative"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="absolute top-2 right-4 text-3xl text-gray-400 hover:text-black leading-none"
                            onClick={() => setFootnote(null)}
                        >
                            &times;
                        </button>
                        <div className="text-xs font-bold text-gray-400 uppercase mb-3">
                            Footnote {footnote.id}
                        </div>
                        <div className="text-gray-800 leading-relaxed">
                            <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={{
                                    a: ({ href, children, ...props }) => (
                                        <a href={href} className="text-amber-600 hover:underline" target="_blank" rel="noopener noreferrer" {...props}>
                                            {children}
                                        </a>
                                    )
                                }}
                            >
                                  {footnote.note
        .replace(/([^>]+)>>([^\s\]]+)/g, '[$1](https://$2)')
        .replace(/\{/g, '[')
        .replace(/\}/g, ']')}
                            </ReactMarkdown>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Markdown;